import React, { useEffect, useState } from "react";
import logo from "src/assets/images/logo.jpeg";
import { useRecoilState } from "recoil";
import { loadingState } from "src/atom/LoadingState";
import { fetchMetaData } from "src/services/MainPage/OnboardHomeService";

const Heading = () => {
  const [metaData, setMetaData] = useState(false);
  const [loader, enableLoader] = useRecoilState(loadingState);

  const fetchMetaDataAPICall = async () => {
    enableLoader(true);
    try {
      var fetchInstructionsMethod = async () => {
        var response = await fetchMetaData();
        if (response?.success) {
          setMetaData(response.body);
          enableLoader(false);
        } else {
          enableLoader(false);
        }
      };
      enableLoader(false);
      fetchInstructionsMethod();
    } catch (error) { }
  };

  const fetchInstructionsAPICall = async () => {
    try {
      const response = await fetch("/other-instructions.json");
      const data = await response.json();

      if (data?.Heading?.heading) {
        setMetaData(data.Heading.heading);
      }
    } catch (error) {
      console.error(error);
    }
  };


  useEffect(() => {
    // fetchMetaDataAPICall();
    fetchInstructionsAPICall();
  }, []);

  return (
    <>
      <div className="p-2">
        <div className="d-flex justify-content-center align-items-center">
          <img
            style={{ height: "60px", width: "auto", marginRight: "10px" }}
            src={logo}
            alt="Logo"
          />
          <div className="d-flex flex-column align-items-center">
            <span className="mt-2" style={{ fontWeight: "bold" }}>
              हरियाणा कर्मचारी चयन आयोग, पंचकुला
            </span>
            <span style={{ fontWeight: "bold" }}>
              HARYANA STAFF SELECTION COMMISSION, Panchkula
            </span>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row justify-content-center align-items-center">
          <div className="col-md-8 col-lg-12">
            <div
              className="mt-2 text-center"
              style={{ fontWeight: "bold", fontSize: "25px" }}
            >
              {/* {Array.isArray(metaData) &&
                metaData.map(
                  (data, index) =>
                    data.fieldKey === "headline" && (
                      <div key={index}>{data.fieldValue}</div>
                    )
                )} */}
              <div>{metaData}</div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Heading;
